import { render, staticRenderFns } from "./departMentAddModule.vue?vue&type=template&id=f6b56f94&scoped=true"
import script from "./departMentAddModule.vue?vue&type=script&lang=js"
export * from "./departMentAddModule.vue?vue&type=script&lang=js"
import style0 from "./departMentAddModule.vue?vue&type=style&index=0&id=f6b56f94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b56f94",
  null
  
)

export default component.exports